import { createFeature, createReducer, on } from '@ngrx/store';
import { CategoriesResponse } from '../../models/request.model'
import { CategoriesActions } from '../actions/categories.action';


export interface CategoriesState {
  loading: boolean;
  error: string | null;
  data: CategoriesResponse | null;
}


const initialState: CategoriesState = {
  loading: false,
  error: null,
  data: null,
};

const reducer = createReducer(
  initialState,
  on(CategoriesActions.loadCategories, (state) => ({ ...state, loading: true, error: null })),
  on(CategoriesActions.loadCategoriesSuccess, (state, { data }) => ({ ...state, loading: false, data })),
  on(CategoriesActions.loadCategoriesFailure, (state, { error }) => ({ ...state, loading: false, error })),
);



export const categoriesFeature = createFeature({
  name: 'categories',
  reducer,
});

export const {
  name,
  reducer: categoriesReducer,
  selectCategoriesState,
  selectLoading,
  selectError,
  selectData,
} = categoriesFeature;
